function textRange(size, startAt = 0) {
  return [...Array(size).keys()].map(i => `${i + startAt}`);
}

export const seasons = [
  '2009-2010',
  '2010-2011',
  '2011-2012',
  '2012-2013',
  '2013-2014',
  '2014-2015',
  '2015-2016',
  '2016-2017',
  '2017-2018',
  '2018-2019',
  '2019-2020',
  '2020-2021',
  '2021-2022'
];

export const years = textRange(14, 2009);
export const months = textRange(12, 1);
export const days = textRange(31, 1);

export const periods = textRange(5, 1);
export const minutes = textRange(13, 0);
export const seconds = textRange(60, 0);